import {
    HttpResponse,
    ProductModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ProductsDataService implements CrudService<ProductModel, ProductModel> {
    getAll(query: CrudDataQuery<ProductModel>): Promise<CrudEnumerableResponse<ProductModel>> {
        return ApiService.api.getProductBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ProductModel>): Promise<CrudEnumerableResponse<ProductModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProductModel>> {
        return ApiService.api.getProductById(id, params);
    }

    create(item: ProductModel, params?: RequestParams): Promise<CrudResponse<ProductModel>> {
        return ApiService.api.insertProduct(item, params);
    }

    update(item: ProductModel, params?: RequestParams): Promise<ProductModel> {
        return ApiService.api.updateProduct(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProductModel> {
        return ApiService.api.patchProduct(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProductModel>): Promise<CrudEnumerableResponse<ProductModel>> {
        return ApiService.api.deleteProducts(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationProduct(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ProductModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ProductModel, params?: RequestParams): Promise<CrudResponse<ProductModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getProductGroupped(query, params);
    }

}
